import axios from 'axios';

const API_URL = '';

export async function compareFiles(formData: FormData, signal?: AbortSignal) {
  return axios.post(`${API_URL}/api/compare/files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600_000,
    signal,
  });
}

export async function cancelSession(sessionId: string) {
  return axios.post(`${API_URL}/api/cancel/${sessionId}`);
}

export function cancelSessionBeacon(sessionId: string) {
  navigator.sendBeacon(`${API_URL}/api/cancel/${sessionId}`);
}

export async function fetchParsedDocs(sessionId: string) {
  const res = await axios.get(`${API_URL}/api/parsed/${sessionId}`);
  return res.data.documents as { name: string; size: number }[];
}

export async function downloadParsedDoc(sessionId: string, index: number): Promise<{ blob: Blob; filename: string }> {
  const res = await fetch(`${API_URL}/api/parsed/${sessionId}/${index}`);
  if (!res.ok) throw new Error(`Download failed: ${res.status}`);

  const blob = await res.blob();
  const cd = res.headers.get('Content-Disposition');
  let filename = `document_${index + 1}_parsed.txt`;
  if (cd) {
    const match = cd.match(/filename\*=UTF-8''(.+)/);
    if (match) filename = decodeURIComponent(match[1]);
  }
  return { blob, filename };
}
